import type { TAligns } from '@alfa-bank/site-aligner/src/models';
import type { TView } from '@alfa-bank/site-button-v2/src/models';

export const VIEWS: TView[] = [
    'primary',
    'secondary',
    'tertiary',
    'outlined',
    'filled',
    'transparent',
    'link',
    'ghost',
];

export const CENTER = 'center';
export const ALIGNS: TAligns[] = ['left', 'center'];

export const DEFAULT_HEADING_ALIGN = CENTER;
export const DEFAULT_STEP_IMAGE_ALIGN = CENTER;
export const DEFAULT_STEP_TEXT_ALIGN = CENTER;

export const COLUMN_WIDTH_WITH_3_STEPS = [363, 363, 363];
export const COLUMN_WIDTH_WITH_4_STEPS = [266, 266, 266, 266];

export const IMAGE_ALIGN_CENTER = [16, null, 16];
export const IMAGE_ALIGN_LEFT = ['0px', null, 16];
